<template>
    <div id="customreport">
        <HrrBreadcrumb PMname="设备指令与日志" CMname="终端数据日志" />
        <el-tabs v-model="tab" type="card" class="customreport-el-tabs">
            <el-tab-pane label="图表" name="report">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                站点媒体信息（站点-->媒体）
                            </div>
                            <div  class="cab">
                            <el-scrollbar class="cr-infinite-list" >
                                <el-tree highlight-current :data="treeData" :props="defaultProps" node-key="id" :default-expand-all="defaultexpandall" ref="Tree" v-loading="treeloading" @node-click="nodeclick" auto-expand-parent :default-expanded-keys="defaultexpandedkeys">
                                </el-tree>
                            </el-scrollbar>
                        </div>
                        </el-card>
                    </el-col>
                    <el-col :span="19">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <el-form :inline="true" :model="searchform" size="mini">
                                    <el-form-item>
                                        <el-date-picker :editable="false" :clearable="false" v-model="searchform.startDate" placeholder="查看时间"  value-format="yyyy-MM-dd" type="date"></el-date-picker>
                                    </el-form-item>

                                    至<el-form-item>
                                        <el-date-picker :editable="false" :clearable="false" v-model="searchform.endDate" placeholder="查看时间"  value-format="yyyy-MM-dd" type="date"></el-date-picker>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="warning" @click="RefreshClick">刷新</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="ExportClick" v-if="isHadFun('ExportExcel')">导出Excel</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="info" @click="returnClick" v-if="isShowReturn">返回</el-button>
                                    </el-form-item>  
                                </el-form>
                            </div>
                            <ve-line  :data="chartData" :loading="loading" :extend="extend" :after-config="afterconfig" :data-zoom="chartDataZoom" :data-empty="nodata" height="600px" :settings="chartSettings" ref="vcharts" :events="chartEvents"></ve-line>
                        </el-card>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
//import Vue from 'vue';

export default {
    name: 'site_info',
    data() {
        this.extend = {
            yAxis: {
                axisLabel: {
                    color: "#fff"
                },
                nameTextStyle: {
                    color: "#fff"
                }
            },
            xAxis: {
                axisLabel: {
                    color: "#fff"
                }
            },
            series: {
                type: 'line',
                label: {
                    color: "rgba(181, 32, 32, 1)"
                }

            },
            legend: {
                textStyle: {
                    color: "#e6a23c"
                }
            },
            tooltip: {
                formatter: function(params, ticket, callback) {
                    var res = params[0].name;
                    for (var i = 0; i < params.length; i++) {
                        res += "<br>" + params[i].marker + params[i].seriesName + "：" + (params[i].data[1] == null ? "0" : params[i].data[1]);
                    }
                    return res;
                }
            }
        };
        this.chartDataZoom = [{
            type: 'slider',
            textStyle: {
                color: "#fff"
            }
        }];
        this.chartSettings = {
            axisSite: { right: ['亮度'] },
            yAxisName: ['', '亮度(%)'],
        };
        this.chartEvents={
            
            datazoom:(params)=> {
               // console.log(params);
               console.log(this.$refs['vcharts'].echarts.getModel().option);
                let xAxis=this.$refs['vcharts'].echarts.getModel().option.xAxis[0];
                this.leftIndex=xAxis.rangeStart;
                this.rightIndex=xAxis.rangeEnd;
                // console.log(xAxis.data);//axis的标号数据
                // console.log(xAxis.rangeStart);//滑动条左端对应在xAxis.data的索引
                // console.log(xAxis.rangeEnd);//滑动条右端对应在xAxis.data的索引;
            },
            legendselectchanged: (item) => {
                this.legentSelected = item.selected;
                console.log(this.legentSelected );
              }
        };
        return {
            searchform: {
                startDate: "",
                endDate:"",
                deviceCode: "",
            },
            chartData: {},
            defaultexpandall: false,
            tab: "report",
            treeData: [],
            defaultProps: {
                children: 'childList',
                label: 'name'
            },
            treeloading: true,
            loading: true,
            nodata: false,
            defaultexpandedkeys: [],
            isShowReturn: false,
            returnPath: "",
            leftIndex:"" , //保存滑动条的左侧索引值
            rightIndex:"",  //保存滑动条的右侧索引值
            legentSelected:{},   //保存折线图中所有图例选中状态表
        }
    },
    methods: {
        /*PrevDateClick() {
            let cdate = new Date(this.searchform.date);
            this.searchform.date = new Date(cdate.setDate(cdate.getDate() - 1));
            this.initData();
        },
        NexDateClick() {
            let cdate = new Date(this.searchform.date);
            this.searchform.date = new Date(cdate.setDate(cdate.getDate() + 1));
            this.initData();
        },*/
        RefreshClick() {
            this.initData();
        },
        ExportClick(){
            if(this.searchform.deviceCode == ""){
                this.$message({ message: "请选择媒体！", type: "error" });
            }else{
                if(this.chartData.rows.length>0 ){
                    var excelData=[];
                    var columns = [];
                    for(var i=0;i<this.chartData.columns.length;i++){
                        var a=this.chartData.columns[i];
                        if(i>0 && Object.keys(this.legentSelected).length>0){
                            this.legentSelected[a]==true?columns.push(a):"";
                        }else{
                            columns.push(a);
                        }                        
                    }
                    if(columns.length<2){   //未选择指标数据
                        this.$message({ message: "请选择导出数据！", type: "error" });
                    }else{
                        excelData.push(columns);
                    this.leftIndex==""?this.leftIndex=0:"";
                    this.rightIndex==""?this.rightIndex=this.chartData.rows.length-1:"";
                    // 整理设备列表的数组元素
                    for (let i =this.leftIndex; i <=this.rightIndex; i++) {
                        var rows=[];
                        for(var j=0;j<columns.length;j++){
                            var a=columns[j];
                            var value=this.chartData.rows[i][a];
                            rows.push(value);
                        }
                        excelData.push(rows);
                    }
                  // 设置列宽
                    let cols = [
                      { wch: 20 }
                    ]
                    var tabelName=this.searchform.deviceCode+"-"+this.searchform.startDate+"至"+this.searchform.endDate+".xlsx";
                    this.$common.exportExcel(excelData, tabelName, cols)
                    }
                }else{
                    this.$message({ message: "当天无数据！", type: "error" });
                }
            }
            

        },
        afterconfig(options) {
            return options;
        },
        getNFDay(nowDate) {
            var char = "-";
            var completeDate = function(value) {
                return value < 10 ? "0" + value : value;
            }
            if (nowDate == null) {
                nowDate = new Date();
            }
            var day = nowDate.getDate();
            var month = nowDate.getMonth() + 1; //注意月份需要+1
            var year = nowDate.getFullYear();
            //补全0，并拼接
            return year + char + completeDate(month) + char + completeDate(day);
        },
        nodeclick(data, node, o) {
            if (!data.childList) {
                this.searchform.deviceCode = data.id;
                this.initData();
            }
        },
        returnClick() {
            this.$router.push({ path: this.returnPath });
        },
        changetime() {
            this.initData();
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.siteName + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.site.DelSite + "/" + val.siteId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.leftIndex="";
            this.rightIndex="";
            this.legentSelected={};
            this.searchform.startDate = this.getNFDay(new Date(this.searchform.startDate));
            this.searchform.endDate = this.getNFDay(new Date(this.searchform.endDate));
            if (this.searchform.deviceCode != "") {
                this.$hrraxios.get(this.$api.realdata.getOneDate, { params: this.searchform })
                    .then(function(response) {
                        Vuethis.loading = false;
                        var data = response.data;
                        if (data.Success == true) {
                            if (data.Data.rows.length == 0) {
                                Vuethis.nodata = true;
                            } else {
                                Vuethis.nodata = false;
                            }
                            if(Vuethis.searchform.deviceCode=='AD0000000312' || Vuethis.searchform.deviceCode=='AD0000000307'|| Vuethis.searchform.deviceCode=='AD0000000278'){
                                data.Data.rows.forEach(element => {
                                    element['亮度']='70';
                                    element['电流1']=4.29680;
                                });
                            }
                            console.log(data.Data);
                             Vuethis.chartData = data.Data;
                        } else {
                            Vuethis.$message.error(data.Prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            } else {
                this.nodata = true;
                this.loading = false;
            }
        },
        initTree() {
            var Vuethis = this;
            this.treeloading = true;
            this.$hrraxios.get(this.$api.lightbox.tree)
                .then(function(response) {
                    Vuethis.treeloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.treeData = data.Data; 
                        if (Vuethis.$route.params.devicecode) {
                            setTimeout(() => {
                                Vuethis.$refs.Tree.setCurrentKey(Vuethis.searchform.deviceCode);
                            }, 500);
                        }
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.treeloading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            if (this.$route.params.devicecode) {
                this.searchform.deviceCode = this.$route.params.devicecode;
                this.defaultexpandedkeys.push(this.$route.params.devicecode);
                this.isShowReturn = true;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.returnPath = from.path;
        })
    },
    created() {
        let Now = new Date();
        this.searchform.startDate = Now.toLocaleDateString();
        this.searchform.endDate = Now.toLocaleDateString();
        this.$common.getFunListByMCode(this, "LightBoxLogReport", () => {  //siteInfo
            this.initTree();
            this.initParamsData();
            this.initData();
        });
    }
};
</script>
<style>
.customreport-el-tabs {
    margin: 15px;
}

#customreport .el-form-item {
    margin-bottom: 0px;
}

.cab{
    height: 608px; 
}
.cr-infinite-list{
    height: 100%;
    width: 100%;
    white-space: nowrap;
    position: relative;
    overflow: hidden;
}
 .el-scrollbar__wrap{
  overflow-x: auto !important;
  /* height: calc(100% + 20px) !important;   */
}
 .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
  white-space: nowrap;
  display: inline-block;
}

</style>